import { render } from "./BoardTimeline.vue?vue&type=template&id=3fbcdd2d&scoped=true"
import script from "./BoardTimeline.vue?vue&type=script&lang=js"
export * from "./BoardTimeline.vue?vue&type=script&lang=js"

import "./BoardTimeline.vue?vue&type=style&index=0&id=3fbcdd2d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbcdd2d"]])

export default __exports__